module.exports = __webpack_public_path__ + "static/React-icon.svg-c1947e3d784dc5667f7fb02979cd79f6.png";